import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "product-comparison-component" }
const _hoisted_2 = { class: "mb-3 product-comparison-filter" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "instructions" }
const _hoisted_5 = { class: "filter-item form-check" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "products-outer" }
const _hoisted_10 = { class: "products-mid" }
const _hoisted_11 = { class: "products" }
const _hoisted_12 = { class: "product" }
const _hoisted_13 = { class: "product-header" }
const _hoisted_14 = { class: "h5" }
const _hoisted_15 = ["href", "target", "aria-label"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["href", "target", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "instructions", {}, () => [
            _createTextVNode(" Default instructions slot value ")
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
          return (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: product.codename,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedProducts) = $event)),
              value: product.codename
            }, null, 8 /* PROPS */, _hoisted_6), [
              [_vModelCheckbox, _ctx.checkedProducts]
            ]),
            _createTextVNode(),
            _createElementVNode("label", {
              for: product.codename
            }, _toDisplayString(product.name), 9 /* TEXT, PROPS */, _hoisted_7)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleProducts, (product) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(product.name), 1 /* TEXT */),
                    _createElementVNode("p", null, _toDisplayString(product.description), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: product.cta_url,
                      target: product.cta_new_window ? '_blank' : '_self',
                      class: _normalizeClass($options.btnClass(product.cta_class, product.cta_outline)),
                      "aria-label": product.cta_label
                    }, _toDisplayString(product.cta_label), 11 /* TEXT, CLASS, PROPS */, _hoisted_15)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.features, (feature) => {
                  return (_openBlock(), _createElementBlock("div", {
                    innerHTML: feature.feature_text
                  }, null, 8 /* PROPS */, _hoisted_16))
                }), 256 /* UNKEYED_FRAGMENT */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($options.maxFeatures - product.features.length), (index) => {
                  return (_openBlock(), _createElementBlock("div"))
                }), 256 /* UNKEYED_FRAGMENT */)),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: product.cta_url,
                    target: product.cta_new_window ? '_blank' : '_self',
                    class: _normalizeClass($options.btnClass(product.cta_class, product.cta_outline)),
                    "aria-label": product.cta_label
                  }, _toDisplayString(product.cta_label), 11 /* TEXT, CLASS, PROPS */, _hoisted_17)
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ])
      ])
    ])
  ]))
}